import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { CoverageRuleAction } from '@cbridge-packages/coverage-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onValidateCoverageRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(CoverageRuleAction.validate.done),
  mergeMap((payload) => [RulesManagementAction.applyValidation(payload.result)]),
);
